const authTypes = ["local", "dev", "notairedev", "demo", "prod", "none"] as const;

type TargetPlatform = "local" | "remote";

export type EnvType = {
  VITE_TARGET_PLATFORM: TargetPlatform;
  VITE_AUTH: (typeof authTypes)[number];
} & ImportMetaEnv;

// Class to hold the environment variables
export class Env {
  private env: EnvType;

  constructor(env: EnvType) {
    this.env = env;
  }

  get targetPlatform() {
    // always use remote in production
    return this.isProd ? "remote" : this.env.VITE_TARGET_PLATFORM;
  }

  get auth() {
    const authVar = this.env.VITE_AUTH || "none";
    console.assert(
      authTypes.includes(authVar),
      "Env variable `VITE_AUTH` must be one of: ",
      authTypes
    );
    return this.isProd ? "prod" : authVar;
  }

  get isDev() {
    return this.env.DEV;
  }

  get isProd() {
    return this.env.PROD;
  }
}

// An env object created from vitejs environment variables
export const env = new Env(import.meta.env as unknown as EnvType);
